"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const OLDragProvider_1 = require("./OLDragProvider");
const OLHoverProvider_1 = require("./OLHoverProvider");
const OLLayerProvider_1 = require("./OLLayerProvider");
const OLModifyProvider_1 = require("./OLModifyProvider");
const OLSelectionProvider_1 = require("./OLSelectionProvider");
const OLSnapProvider_1 = require("./OLSnapProvider");
function OLProvider({ children }) {
    return (jsx_runtime_1.jsx(OLLayerProvider_1.OLLayerProvider, { children: jsx_runtime_1.jsx(OLSelectionProvider_1.OLSelectionProvider, { children: jsx_runtime_1.jsx(OLHoverProvider_1.OLHoverProvider, { children: jsx_runtime_1.jsx(OLDragProvider_1.OLDragProvider, { children: jsx_runtime_1.jsx(OLModifyProvider_1.OLModifyProvider, { children: jsx_runtime_1.jsx(OLSnapProvider_1.OLSnapProvider, { children: children }, void 0) }, void 0) }, void 0) }, void 0) }, void 0) }, void 0));
}
exports.OLProvider = OLProvider;
//# sourceMappingURL=OLProvider.js.map